export const MINIMUM_COLUMN_WIDTH = 100;

export const TEST_ID = 'withResize';
